import { useCallback, useContext } from "react";
import { ModalContext } from "../../../contexts/ModalContext";
import { captureRequestError } from "../../../helper/captureRequestError";
import { useReportError } from "../../../helpers/useReportError";
import {
  useMutationUpdateAccountAccess,
  SUBSCRIPTION_UPDATE_DELAY,
} from "../../../store/useMutationUpdateAccountAccess";

export function useRemoveBillingOwnerDialog({ accountId }) {
  const reportError = useReportError();

  // update access
  const { mutateAsync: updateAccountAccess } =
    useMutationUpdateAccountAccess(accountId);

  const { openModal, setBtn2Loading, closeModal } = useContext(ModalContext);

  const removeBillingOwnerPrompt = useCallback(
    (billingOwnerId: string) => {
      openModal({
        type: "confirmation",
        icon: "delete",
        heading: "Remove Billing Owner?",
        contents: [
          "This will immediately remove the billing owner’s access and cancel the active subscription. Any remaining time on the plan will be lost.",
          "To regain access to features, you’ll need to purchase a new subscription.",
        ],
        btn2Content: "Remove",
        btn2Action: async () => {
          setBtn2Loading(true);
          try {
            await updateAccountAccess({
              ops: [
                {
                  action: "delete",
                  userId: billingOwnerId,
                },
              ],
            });
            // close modal after update delay
            setTimeout(closeModal, SUBSCRIPTION_UPDATE_DELAY);
          } catch (error) {
            captureRequestError(error);
            reportError(error);
            setBtn2Loading(false);
          }
        },
      });
    },
    [closeModal, openModal, reportError, setBtn2Loading, updateAccountAccess],
  );

  return removeBillingOwnerPrompt;
}
